import { ActionIcon, Paper, Stack } from '@mantine/core'
import { FaForward, FaPause, FaPlay } from 'react-icons/fa'
import classes from './StartPauseSkipButtons.module.css'
import { NavigationDataResponse } from '@/api/navigationApi/types.gen'

const StartPauseSkipButtons = ({
  onPause,
  onResume,
  onStart,
  onSkipSegment,
  isStartDisabled,
  isPauseDisabled,
  isSkipDisabled,
  moduleState,
  hideSkip,
}: {
  moduleState?: NavigationDataResponse['route_module_state']
  onPause: () => void
  onStart: () => void
  onResume: () => void
  onSkipSegment: () => void
  isStartDisabled: boolean
  isPauseDisabled: boolean
  isSkipDisabled: boolean
  hideSkip: boolean
}) => {
  return (
    <Stack gap="xs" className={classes.actionButtons}>
      {moduleState === 'Driving' ? (
        <Paper p={0} shadow="xs" withBorder>
          <ActionIcon size={64} onClick={onPause} disabled={isPauseDisabled} variant="filled" color="blue">
            <FaPause />
          </ActionIcon>
        </Paper>
      ) : moduleState === 'Paused' || moduleState === 'Fetched' ? (
        <Paper p={0} shadow="xs" withBorder>
          <ActionIcon
            size={64}
            onClick={moduleState === 'Paused' ? onResume : onStart}
            disabled={isStartDisabled}
            variant="filled"
            color="teal"
          >
            <FaPlay />
          </ActionIcon>
        </Paper>
      ) : null}
      {(moduleState === 'Driving' || moduleState === 'Paused') && !hideSkip && (
        <Paper p={0} shadow="xs" withBorder>
          <ActionIcon size={64} onClick={onSkipSegment} disabled={isSkipDisabled} variant="filled" color="orange">
            <FaForward />
          </ActionIcon>
        </Paper>
      )}
    </Stack>
  )
}

export default StartPauseSkipButtons
